<template>
    <v-dialog
        :value="dialog"
        persistent
        width="89vw"
        max-width="450px"
        overlay-color="#909090"
        overlay-opacity="1"
    >
        <v-card
            class="elevation-0 mb-4"
            v-if="company"
        >
            <v-card-text class="pa-6" >
                <v-row>
                    <v-col class="text-center">
                        <v-img
                            class="mx-auto mb-3 mt-5"
                            :src="company.logo"
                            tile
                            width="200"
                            contain
                        ></v-img>
                        <p class="title mb-3">
                            Do you have an account with this company?
                        </p>

                        <v-checkbox
                            class="mt-0"
                            style="height: 22px;"
                            v-model="doNotAskAgain"
                            label="Don't show this again."
                        ></v-checkbox>

                        <div class="d-flex justify-space-between mt-24">
                            <v-btn
                                class="text-capitalize px-8 red rounded-lg"
                                text
                                color="white"
                                large
                                @click="answer(false)"
                            >
                                No
                            </v-btn>
                            <v-spacer />
                            <v-btn
                                class="text-capitalize px-10 rounded-lg"
                                color="primary"
                                dark
                                depressed
                                large
                                @click="answer(true)"
                            >
                                Yes
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            company: null,
            itemKey: 'kaoshi-ask-have-account-with-company',
            doNotAskAgain: false,
            resolve: () => {},
        };
    },
    methods: {
        confirm(company) {
            const value = localStorage.getItem(this.itemKey)
            if (value === 'true') {
                this.dialog = false;
                this.company = null;
                return Promise.resolve(true);
            }

            return new Promise((r) => {
                this.resolve = r;
                this.company = company;
                this.dialog = true;
            });
        },
        answer(result) {
            if (result && this.doNotAskAgain) {
                localStorage.setItem(this.itemKey,'true')
            }

            this.resolve(result);
            this.dialog = false;
            this.company = null;
        },
    },
}
</script>
